import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Ana Sayfa', path: '/' },
    { name: 'Hakkımızda', path: '/about' },
    { name: 'Hizmetlerimiz', path: '/services' },
    { name: 'İletişim', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass-effect border-b border-sage-green/10">
      <div className="container">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="h-16 w-16 overflow-hidden flex items-center justify-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_counseling-center-4/artifacts/5b6tpl6s_KAVI%CC%87%20PSI%CC%87KOLOJI%CC%87%20%281%29.png"
                alt="Kavi Psikoloji"
                className="w-auto h-auto scale-[2.8] origin-center transform group-hover:scale-[3] transition-transform duration-300"
              />
            </div>
            <span className="font-semibold text-lg text-forest-green hidden sm:block tracking-wide">Kavi Psikoloji</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium transition-colors duration-300 relative group ${
                  isActive(item.path) ? 'text-sage-green' : 'text-text-light hover:text-sage-green'
                }`}
              >
                {item.name}
                <span
                  className={`absolute -bottom-1 left-0 w-0 h-0.5 bg-sage-green transition-all duration-300 group-hover:w-full ${
                    isActive(item.path) ? 'w-full' : ''
                  }`}
                />
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <a href="tel:+905305128090" className="hidden md:block">
            <Button className="bg-sage-green hover:bg-forest-green text-white button-hover">
              <Phone className="w-4 h-4 mr-2" />
              Hemen Ara
            </Button>
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-sage-green hover:bg-sage-green/10 rounded-lg transition-colors"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t border-sage-green/10 glass-effect">
          <nav className="container py-4 flex flex-col space-y-3">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive(item.path)
                    ? 'bg-sage-green text-white'
                    : 'text-text-light hover:bg-sage-green/10 hover:text-sage-green'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <a href="tel:+905305128090">
              <Button className="w-full bg-sage-green hover:bg-forest-green text-white">
                <Phone className="w-4 h-4 mr-2" />
                Hemen Ara
              </Button>
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};